import { Menu, Dropdown, Icon, Row, Col, Modal, Alert, Divider, Popover, Select, Radio, Steps, Card } from 'antd';
import sc from 'styled-components';
import React, { Component } from 'react';
import { GRAY_LIGHT } from '../../../views/styleConstants';
import Button from '../../../views/StyledButton';
import { Category } from '../../../store/models/Category';
import Textarea from '../../../views/TextAreaBouncy';
import Input from '../../../views/InputBouncy';
import SQstore from './saveQuatDialogStore';
import ButtonList from '../../../views/ButtonList';
import { HelpText, TextAreaHead } from '../../../views/typography';
import { FormRow } from '../../../views/Form';

export default class SaveQuategoryDialog extends Component {
  constructor(props) {
    super(props);
    this.handleOk = this.handleOk.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.store = SQstore(props);
    this.state = {};
  }

  handleOk() {
    const category = this.categoryRecord();
    console.log('saving category ', category);
    this.props.save(category);
    this.store.actions.reset();
  }

  handleCancel() {
    this.props.save(false);
  }

  categoryRecord() {
    const {
      name, version, notes, tags, description, isCategory, query,
    } = this.store.state;
    const category = new Category({
      categoryName: name,
      version,
      notes,
      query,
      categoryDescription: description,
      active: (!!isCategory),
    });
    category.textToTags(tags);
    return category;
  }

  componentDidMount() {
    this._stateSub = this.store.subscribe((store) => {
      this.setState(state => ({ ...state, ...store.state }));
    }, (err) => {
      console.log('error on store: ', err);
      this.store.restart();
    }, () => {
      console.log('end of subscribe');
    });
    this.store.actions.checkName();
    this.store.actions.setStep(0);
  }

  componentWillUnmount() {
    this.unmounted = true;
    if (this._stateSub) {
      this._stateSub.unsubscribe();
    }
  }

  getSnapshotBeforeUpdate(prevProps) {
    if ((prevProps.query !== this.props.query)
      || (prevProps.name !== this.props.name)
      || (prevProps.isCategory === this.props.category)
    ) {
      this.store.actions.update(this.props);
    }
    return null;
  }

  canSave() {
    return this.categoryRecord().isValid;
  }

  render() {
    const { showSaveDialog } = this.props;
    const {
      query, name, isCategory, savedUnderName,
      description, version, notes, step, tags,
    } = this.store.state;
    const {
      chooseName, asQuery, asCategory, chooseNotes, makeUnique,
      chooseDescription, chooseVersion, chooseTags, rechooseType,
    } = this.store.actions;

    const TYPE_NAME = isCategory ? 'Category' : 'Query';

    const alert = savedUnderName ? (<Alert
      type="warning"
      banner
      message={`There is a ${savedUnderName.active ? 'Category' : 'Query'} named "${name}."`}
      description={`Saving this ${TYPE_NAME} will update(overwrite) it. 
      This will not change past indexed media but will revise how/if future media are indexed.
       If you do not want to overwrite "${name}", choose a different name (or click "Increment"). `}
    />) : (<Alert
      type="info"
      closable
      banner
      message={`There are no filters named "${name}."`}
      description={
        `Saving this ${TYPE_NAME} will save a new filter.`
      }
    />);

    return (<Modal
        width={650}
        title={`Save filter "${name}"`}
        visible={showSaveDialog}
        footer={null}
        okText="Save"
        onCancel={this.handleCancel}
      >
        <Steps current={step} size="small" style={({ marginBottom: '1rem' })}>
          <Steps.Step
            key={0}
            title="Choose Mode"
            description={step ? TYPE_NAME : ''}
            onClick={rechooseType}
          >
          </Steps.Step>
          <Steps.Step
            key={1}
            title="Annotate and Save"
          >
          </Steps.Step>
        </Steps>
        <FormRow bottomMargin={2} tall label="Name">
          <Input
            value={name}
            onChange={chooseName}
            addonAfter={savedUnderName ?
              <Button type="link" size="small" onClick={makeUnique}>Increment</Button> : false}
          />
        </FormRow>
        {step !== 0 ? '' : (
          <React.Fragment>
            <Row gutter={16}>
              <Col span={12}>
                <Button
                  type="primary"
                  block
                  onClick={asCategory}
                  icon="right"
                > Save as a CATEGORY
                </Button>
              </Col>
              <Col span={12}>
                <Button
                  type="primary"
                  block
                  onClick={asQuery}
                  icon="right"
                >
                  Save as a QUERY
                </Button>
              </Col>
            </Row>
            <Divider />
            <Row gutter={16}>
              <Col span={12}>
                <p>
                  Your filter will be applied as a <b>Category</b>.
                  It will be applied to all future media.
                </p>
              </Col>
              <Col span={12}>
                <p>Your filter will be saved as a <b>Query</b>.
                   It&apos;s syntax won&apos;t be checked for errors,
                   and it will not be applied to future media.
                </p>
              </Col>
            </Row>
            {alert}
            <ButtonList expandFirst>
              <Button type="default" onClick={this.handleCancel}> Cancel</Button>
              <span>&nbsp;</span>
            </ButtonList>
          </React.Fragment>
        )}
        {
          step !== 1 ? '' : (
            <React.Fragment>
              <FormRow bottomMargin={2} tall label="Version"><Input value={version} onChange={chooseVersion} />
              </FormRow>
              <TextAreaHead>Description</TextAreaHead>
              <Textarea maxRows={4} value={description || ''} onChange={chooseDescription} />
              <TextAreaHead>Notes</TextAreaHead>
              <Textarea maxRows={4} value={notes || ''} onChange={chooseNotes} />
              <TextAreaHead>Tags: <i>Put each tag on its own line</i></TextAreaHead>
              <Textarea maxRows={4} value={tags || ''} onChange={chooseTags} />

              <ButtonList expandFirst>
                <Button type="default" onClick={this.handleCancel}> Cancel</Button>
                <Button type="default" onClick={rechooseType} icon="left">Re-choose Type</Button>
                <Popover
                  placement="top"
                  overlayClassName="tight-popover"
                  overlayStyle={({
                    maxWidth: 400,
                  })}
                  content={alert}
                >
                  <Button type="primary" onClick={this.handleOk} disabled={!this.canSave()}>{savedUnderName ? 'Update' : 'Publish'}{' '}{TYPE_NAME} "{name}"</Button>
                </Popover>
              </ButtonList>
            </React.Fragment>
          )
        }
      </Modal>
    );
  }
}
